import { fromJS, List, Map, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { ITrackingObject } from '../../tracking/tracking.data';

export const PROMO_BANNER_SCHEMA = Object.freeze({
  TITLE: '',
  DESCRIPTION: '',
  ICON: null, // IIcon
  LOGO_SRC: '', // image src
  HIDE_CLOSE: false,
  CTA1: null, // IRouter
  CTA2: null, // IRouter
  CTA1_ACTIONS: List<any>([]),
  CTA2_ACTIONS: List<any>([]),
  LOCAL_STORAGE_KEY: null, // string
  TRACKING_OBJECT: null, // ITrackingObject
});
const RECORD = generateSchema(PROMO_BANNER_SCHEMA);
const KEYS: any = generateKeys(PROMO_BANNER_SCHEMA);

// TODO [adoption-cards]: this will be replaced by adoption card model
export class PromoBanner extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }

  get description(): string {
    return this.get(KEYS.DESCRIPTION);
  }

  get icon(): Map<string, any> {
    return this.get(KEYS.ICON);
  }

  get logoSrc(): string {
    return this.get(KEYS.LOGO_SRC);
  }

  get hideClose(): boolean {
    return this.get(KEYS.HIDE_CLOSE);
  }

  get cta1(): Map<string, any> {
    return this.get(KEYS.CTA1);
  }

  get cta2(): Map<string, any> {
    return this.get(KEYS.CTA2);
  }

  get cta1Actions(): List<any> {
    return this.get(KEYS.CTA1_ACTIONS);
  }

  get cta2Actions(): List<any> {
    return this.get(KEYS.CTA2_ACTIONS);
  }

  get localStorageKey(): string {
    return this.get(KEYS.LOCAL_STORAGE_KEY);
  }

  get trackingObject(): ITrackingObject {
    return this.get(KEYS.TRACKING_OBJECT);
  }
}
